/*
 * Breakpoints shared between the banner components and the stylesheet.
 * Keep this in sync with the PHASE 25 media query in _asset/css/circus.css.
 */

/** Matches `$device_lg` (1060px) — the project's own desktop/mobile switch. */
export const MOBILE_MEDIA_QUERY = '(max-width: 1060px)'

/**
 * Matches the PHASE 25 rail media query (1880px) — the narrowest desktop that
 * can carry the left/right banner rails beside the centre column.
 *
 * Derived from Patek's real dimensions, not picked at random. The banners are
 * shown whole, at the vertical 1:2 the artwork is drawn at, so a card as tall
 * as the hero + info row section (54.4rem) is 27.3rem wide and the two rails
 * need 59.4rem of page width between them. The page column — `.container`,
 * `max-width: $containerSize` = 146rem = 1460px at the 10px root font size —
 * gives that up rather than the banners: it shrinks to 128.6rem at 1880px and
 * is back at its full 146rem from ~2054px up. Below 1880px it would have to
 * give up more than that, which is where this line is drawn.
 *
 * Deliberately NOT 1920px even though that is the common monitor width: a
 * media query is matched against the layout viewport, which on a machine with
 * classic scrollbars is ~15px narrower than the screen, so `min-width: 1920px`
 * would never match on exactly the monitors it was meant for.
 *
 * Below this the rails are not rendered at all — no DOM, and no request for
 * artwork nobody will see — and the centre column is untouched.
 */
export const SIDE_RAIL_MEDIA_QUERY = '(min-width: 1880px)'
